import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import emailIcon from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import messageIcon from "Assets/newicons/user-interface/message/outline/message-outline-32px.svg";
import check from "Assets/Svg/check.svg";
import invite from "Assets/Svg/invite.svg";
import IconLabel from "Component/Labels/IconLabel";
import SearchSq from "Component/Material-ui/SearchSq";
import LabelIcon from "Component/Labels/LabelIcon";
import TextField from "Component/Material-ui/TextField";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Helmet } from "react-helmet";
import {
  FormattedMessage,
  IntlProvider,
} from "react-intl";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { SubscriptionLogin } from "../../../Actions/AuthenticationAction";
import { instance } from "../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../Actions/commonAction";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import employee from "../../../Assets/Images/employee.svg";
import headersList from "../../../Constants/headersList";
import createstore from "../../../store";
import { DateTimeConversion } from "../../../Utils/dates";
import "./Profile.css";

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px dashed rgb(102, 102, 102)",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
  borderWidth: 2,
};

class InviteEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
       subscriptionid: "",
      date: false,
      port: window.location.port,
      HelperSlider: false,
      permissions: { readOnly: false, editable: false },
      livedatapermission: { readOnly: false, editable: false },
      prospectemployeedata: [],   
      allLoadedEmployeeData: [], 
      searchTerm: '',           
      totalEmployeeCount: 0,     
      offset: 0,                 
      limit: 10,                
      loading: false,          
      hasMore: true,            
      empdata: [ 
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
      ],
      open: false,      
      value: 0,        
      invited0: false,  
      invited1: false, 
      sectionFeilds: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.openDilogGrid = this.openDilogGrid.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.OnPhoneChange = this.OnPhoneChange.bind(this);
    this.setTabValue = this.setTabValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.sendDetails = this.sendDetails.bind(this);
    this.addmorerows = this.addmorerows.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.tableContainerRef = React.createRef(); 
  }

  openDilogGrid() {
    this.setState({
      open: true,
    });
  }
  getProspectEmployee(resetOffset = false) {
    this.setState({ loading: true });
    const currentOffset = resetOffset ? 0 : this.state.offset;

    instance
      .get(`account/getprospectemployee/${currentOffset}/${this.state.limit}`)
      .then((resp) => {
        const newEmployees = get(resp, "data.result", []);
        let updatedTotalCount = this.state.totalEmployeeCount;
        if (newEmployees.length > 0 && newEmployees[0].fullcount !== undefined) {
          updatedTotalCount = parseInt(newEmployees[0].fullcount);
        }
        this.setState(prevState => {
          const updatedAllLoadedData = resetOffset 
            ? newEmployees 
            : [...prevState.allLoadedEmployeeData, ...newEmployees];
          
          const hasMorePages = newEmployees.length === prevState.limit;
          const displayedData = prevState.searchTerm
            ? updatedAllLoadedData.filter(emp =>
                (emp.fullname && emp.fullname.toLowerCase().includes(prevState.searchTerm.toLowerCase())) ||
                (emp.emailid && emp.emailid.toLowerCase().includes(prevState.searchTerm.toLowerCase())) ||
                (emp.primarymobile && String(emp.primarymobile).includes(prevState.searchTerm))
              )
            : updatedAllLoadedData;

          return {
            allLoadedEmployeeData: updatedAllLoadedData, 
            prospectemployeedata: displayedData,     
            totalEmployeeCount: updatedTotalCount,     
            loading: false,
            hasMore: hasMorePages && updatedAllLoadedData.length < updatedTotalCount, 
            offset: currentOffset, 
          };
        });
      })
      .catch((error) => {
        console.error("Error fetching prospect employees:", error);
        this.props.enqueueSnackbar("Failed to load employee stats.", { variant: "error" });
        this.setState({ loading: false });
      });
  }

  addmorerows() {
    const { empdata } = this.state;
    const row = {
      firstname: "",
      middlename: null,
      lastname: "",
      emailid: "",
      primarymobile: "",
      callingcode: "",
      mobile: "",
      isEmailtrue: false,
    };
    empdata.push(row);
    this.setState({ empdata });
  }

  handleScroll = (e) => {
    const { loading, hasMore } = this.state;
    const element = e.target;

    if (
      element.scrollHeight - element.scrollTop <= element.clientHeight + 100 &&
      !loading &&
      hasMore
    ) {
      this.setState(
        prevState => ({ offset: prevState.offset + prevState.limit }),
        () => this.getProspectEmployee()
      );
    }
  };

  onDelete(row) {
    const data = {
      employeeid: row.employeeid,
      prospectemployeeid: row.prospectemployeeid,
    };

    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .post("employee/delemp", data)
              .then(() => {
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
                this.setState(prevState => {
                    const newAllLoadedData = prevState.allLoadedEmployeeData.filter(
                        emp => emp.prospectemployeeid !== row.prospectemployeeid
                    );
                    const newProspectData = prevState.searchTerm
                        ? newAllLoadedData.filter(emp =>
                            (emp.fullname && emp.fullname.toLowerCase().includes(prevState.searchTerm.toLowerCase())) ||
                            (emp.emailid && emp.emailid.toLowerCase().includes(prevState.searchTerm.toLowerCase())) ||
                            (emp.primarymobile && String(emp.primarymobile).includes(prevState.searchTerm))
                          )
                        : newAllLoadedData;
                    const newTotalEmployeeCount = Math.max(0, prevState.totalEmployeeCount - 1);
                    const hasMoreAfterDelete = newAllLoadedData.length < newTotalEmployeeCount;

                    return {
                        totalEmployeeCount: newTotalEmployeeCount, 
                        allLoadedEmployeeData: newAllLoadedData, 
                        prospectemployeedata: newProspectData, 
                        offset: 0,
                        hasMore: hasMoreAfterDelete,
                        loading: false, 
                    };
                }, () => {
                    this.getProspectEmployee(true); 
                });
              })
              .catch((error) => {
                this.props.closeSnackbar();
                this.props.enqueueSnackbar(
                    error.response ? error.response.data.error.message : error.message,
                    { variant: "error" },
                );
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  sendDetails() {
    const employeedetails = [];
    if (this.state.value == 0) {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.isEmailtrue) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    } else {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.primarymobile) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    }

    const data = {
      employeedata: employeedetails,
      issms: this.state.value == 0 ? false : true,
    };
    console.log("data: ", data);
    const URL = `account/prospectemployee/${get(
      this.props,
      "AuthenticationAction.login.subscriptionid",
      "",
    )}`;

    if (employeedetails.length > 0) {
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Invite Sent Succesfully", {
            variant: "success",
          });
          if (this.state.value == 1) {
            this.setState({
              invited1: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          } else {
            this.setState({
              invited0: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          }
          this.getProspectEmployee(true);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  handleChange(name, e, index) {
    const { empdata } = this.state;
    empdata[index][name] = e;
    this.setState({
      empdata,
    });
  }

  validateEmail(value, index) {
    const { empdata } = this.state;
    const currentemail = value;
    if (currentemail != "") {
      if (
        /^\w+([\.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(
          currentemail,
        )
      ) {
        const x = empdata.find(
          (email, index1) => index != index1 && email.emailid == currentemail,
        );
        if (x) {
          this.props.enqueueSnackbar("Please enter unique email ID", {
            variant: "error",
          });
          empdata[index].isEmailtrue = false;
        } else {
          empdata[index].isEmailtrue = true;
        }
        this.setState({ empdata });
      } else {
        empdata[index].isEmailtrue = false;
        this.setState({ empdata });
        this.props.enqueueSnackbar("Please enter valid email ID", {
          variant: "error",
        });
      }
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  OnTabChange = (event, value) => {
    this.setState({ value });
  };

  setTabValue(value) {
    this.setState({ value });
  }

  OnPhoneChange(index, field, value) {
    const { empdata } = this.state;
    if (empdata[index]) {
      empdata[index].callingcode = value.dialCode;
      empdata[index].mobile = field;
    }
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    const x = no.trim();
    empdata[index].primarymobile = x;
    this.setState({ empdata });
  }

  handleSearch = (searchTerm) => {
    const { allLoadedEmployeeData } = this.state;
    if (searchTerm) {
      const filtered = allLoadedEmployeeData.filter(emp =>
        (emp.fullname && emp.fullname.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (emp.emailid && emp.emailid.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (emp.primarymobile && String(emp.primarymobile).includes(searchTerm))
      );

      this.setState({
        searchTerm,
        prospectemployeedata: filtered
      });
    } else {
      this.setState({
        searchTerm: '',
        prospectemployeedata: [...allLoadedEmployeeData]
      });
    }
  };

  componentDidMount() {
    this.props.ChangeLanguage("addEmployee");
    const { AuthenticationAction } = createstore.getState();
    this.setState({
      DateFormat: AuthenticationAction.login.dateformat,
      subscriptionid: AuthenticationAction.login.subscriptionid,
      accountid: AuthenticationAction.login.accountid,
      fullname: AuthenticationAction.login.fullname,
      firstname: AuthenticationAction.login.firstname,
    });
    this.props.setHelperText({ helperText: "hello", open: false });
    const [isok, livedatapermission] = CheckActionPermission("livedata_newemployee");
    const [isTrue, permissions] = CheckActionPermission("inviteEmployee");

    if (isTrue) {
      this.setState({ permissions, livedatapermission }, () => {
        this.GetData();
        this.getProspectEmployee();
        if (this.tableContainerRef.current) {
          this.tableContainerRef.current.addEventListener('scroll', this.handleScroll);
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    if (this.tableContainerRef.current) {
      this.tableContainerRef.current.removeEventListener('scroll', this.handleScroll);
    }
  }

  HelperSliderFlag(flag, text) {
    this.props.setHelperText({ helperText: text, open: flag });
  }

  GetData() {
    const URL = `employee/getsubscriptionotp/${this.state.subscriptionid}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result[0];
        const URL = window.location.host;
        // let employeeLink = `http://${data.subdomain}.sumhr.io/newemployee`
        const employeeLink = `${window.location.origin}/newemployee`;
        const { subscriptionotp } = data;
        const { updatedbyname } = data;
        const { updateddate } = data;
        // let updateddate = undefined
        const companyName = data.subscriptionname;
        const copyText = `Hi,

Welcome to ${companyName}.

Please add yourself as an employee by clicking here: 
${employeeLink}

and use the Company OTP ${subscriptionotp} to access the above link

Best Regards,
${this.state.fullname}`;

        this.setState({
          employeeLink,
          subscriptionotp,
          updatedbyname,
          updateddate,
          copyText,
        });
        if (
          !updateddate ||
          // || updateddate == undefined ||
          // updateddate == null ||
          !subscriptionotp
          // || subscriptionotp == undefined ||
          // subscriptionotp == null
        ) {
          this.setState({ date: false });
          this.RefreshOTP();
        } else {
          this.setState({ date: true });
        }
      })
      .catch((error) => {
        this.setState({
          CommonError: error.message,
        });
      });
  }

  RefreshOTP() {
    const data = {
      subscriptionid: this.state.subscriptionid,
    };
    const URL = "employee/updatesubscriptionotp";
    instance
      .post(URL, data)
      .then((result) => {
        const data = result.data.result;
        const { subscriptionotp } = data;

        this.setState({ subscriptionotp }, () => {
          this.GetData();
        });
        // this.setState({
        //     ...result.data.result,
        // })
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { value } = this.state;
    const language = this.props.Language.addEmployee;

    return (
      <div className="application">
        <Helmet>
          <title>{headersList.InviteNewEmployee.header}</title>
        </Helmet>
        <IntlProvider locale="en" messages={language}>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <main className="content-outer-wrapper">
              <div>
                <Grid container className="padding-bottom-30">
                  <Grid item xs={12} md={6} sm={12}>
                    <div className="hello-welcome align-center" align="left">
                      <FormattedMessage id="HdHello" defaultMessage="Hello" />
                      <span className="margin-left-10">
                        {this.state.firstname}
                      </span>

                      <div className="login-into-your-sumhr" align="left">
                        <FormattedMessage
                          id="LbAddemployeesubdetail"
                          defaultMessage="Let's add an employee by sharing the link & OTP or bulk upload details to add employees directly."
                        />
                      </div>

                      <div align="center" className="padding-top-30">
                        <img src={employee} height="236" />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} sm={12}>
                    <div className="width80 align-center">
                      <div className="position-rel">
                        <div className="position-rel width100">
                          <div className="add-employee-label padding-top-0">
                            <svg width="20" height="15" viewBox="0 0 24 24">
                              <path
                                fill="#666"
                                d="M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
                              />
                            </svg>
                            <FormattedMessage
                              id="LbAddemployeelink"
                              defaultMessage="Add Employee Link"
                            />
                          </div>

                          <div className="add-employee-data">
                            <span
                              style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "block",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {this.state.employeeLink}
                            </span>
                          </div>
                        </div>
                        {/* <div className="support-icons cursurpointer" onClick={this.HelperSliderFlag.bind(this, true, "Question mark")} style={{top:55}}>
                                            <svg width="24" height="24" viewBox="0 0 24 24">

                                                <path fill="#666" d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" /></svg>
                                        </div> */}
                      </div>

                      <div className="position-rel">
                        <div className="position-rel width100">
                          <div className="add-employee-label">
                            <svg width="20" height="15" viewBox="0 0 24 24">
                              <path
                                fill="#666"
                                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                              />
                            </svg>
                            <FormattedMessage
                              id="LbCompanyotp"
                              defaultMessage="Company OTP"
                            />
                          </div>
                          <div className="add-employee-data">
                            <span>
                              {this.state.subscriptionotp}
                              <br />
                              <span
                                className="otprefresh cursurpointer"
                                onClick={this.RefreshOTP.bind(this)}
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                  <path
                                    fill="#666"
                                    d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
                                  />
                                </svg>
                              </span>

                              {/* <Moment parse="YYYY-MM-DD HH:mm"> */}
                              {/* <Moment format={this.state.DateFormat}> */}
                              {/* {this.state.updateddate} */}
                              {/* </Moment> */}

                              {/* {this.state.date ? Moment(this.state.updateddate).format(this.state.DateFormat) : ''} */}
                            </span>
                            {/* {(item.companydoj).format("MMM YYYY")} */}
                          </div>
                          <span
                            style={{
                              color: "grey",
                              fontSize: 14,
                              display: "block",
                              marginTop: 8,
                            }}
                          >
                            <FormattedMessage
                              id="LbUpdatedBy"
                              defaultMessage="Updated by"
                            />{" "}
                            {this.state.updatedbyname}{" "}
                            <FormattedMessage
                              id="Lbon"
                              defaultMessage="on"
                            />{" "}
                            &nbsp;
                            {this.state.updateddate
                              ? DateTimeConversion(
                                this.state.updateddate,
                                this.state.DateFormat,
                              )
                              : ""}
                          </span>
                        </div>

                        {/* <div className="support-icons cursurpointer" onClick={this.HelperSliderFlag.bind(this, true, "Question mark 2")} style={{top:55}}>
                                            <svg width="24" height="24" viewBox="0 0 24 24">

                                                <path fill="#666" d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" /></svg>
                                        </div> */}
                      </div>
                      <div className="padding-top-20 display-flex">
                        <CopyToClipboard text={this.state.copyText}>
                          <Button
                            variant="contained"
                            className="width50 margin-right-16 btn btn-primary-md-blue"
                          >
                            Copy link & OTP
                          </Button>
                        </CopyToClipboard>

                        {this.state.permissions.editable &&
                          (this.state.livedatapermission.readOnly ||
                            this.state.livedatapermission.editable) ? (
                          <div
                            className="display-flex"
                            style={{ alignItems: "center" }}
                          >
                            <p className="small-dark-secondary margin-right-16">
                              Or
                            </p>

                            <Link
                              to={`live_data/addnewemployee`}
                              target="_blank"
                            >
                              <Button
                                variant="contained"
                                className="btn btn-primary-md-blue width100"
                              >
                                Bulk add
                              </Button>
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="margin-bottom-24 margin-top-24">
                        <LabelIcon label="Expanding your team?" img={invite} />
                        <Paper
                          className="padding16 rounded-rectangle-paper cursor-pointer"
                        // onClick={this.openDilogGrid}
                        >
                          <div
                            className="display-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <p className="normal-dark-secondary">
                              Invite team member(s)
                            </p>

                            {/* <img
                            className="cursurpointer"
                            src={rightarrow}
                            style={{ fontSize: 26 }}
                          ></img> */}
                          </div>
                          <div className="margin-top-16 display-flex">
                            <div
                              onClick={() => {
                                this.setState({
                                  value: 0,
                                });
                                this.openDilogGrid();
                              }}
                              className="margin-right-24"
                            >
                              <IconLabel
                                label="Invite via email"
                                img={emailIcon}
                                labelClassNames="small-blue"
                              />
                            </div>
                            <div
                              onClick={() => {
                                this.setState({
                                  value: 1,
                                });
                                this.openDilogGrid();
                              }}
                            >
                              <IconLabel
                                label="Invite via SMS"
                                img={messageIcon}
                                labelClassNames="small-blue"
                              />
                            </div>
                          </div>
                        </Paper>
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p className="normal-dark-secondary t-bold">
                     Prospect employees
                    </p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span className="normal-dark-secondary" style={{
                      marginRight: '10px',
                      // backgroundColor: '#e0e0e0',
                      borderRadius: '12px',
                      padding: '4px 12px',
                      fontSize: '15px',
                      fontWeight: '500',
                      whiteSpace: 'nowrap'
                    }}>
                    ( {this.state.prospectemployeedata.length} of {this.state.allLoadedEmployeeData.length} / {this.state.totalEmployeeCount} )
                    </span> 
                    <SearchSq
                      placeholder="Search employees..."
                      onChange={(e) => this.handleSearch(e.target.value)}
                      value={this.state.searchTerm}
                    />
                  </div>
                </div>
                <div className="table-container" style={{ maxHeight: '500px', overflowY: 'auto' }} ref={this.tableContainerRef}>
                  <Table>
                    <TableHead style={{ background: "#edf5fd" }}>
                      <TableRow>
                        <TableCell>
                          <p className="small-dark-secondary t-bold">
                            Prospect employee
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="small-dark-secondary t-bold">Email ID</p>
                        </TableCell>
                        <TableCell>
                          <p className="small-dark-secondary t-bold">
                            Mobile number
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="small-dark-secondary t-bold">
                            Invited date
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="small-dark-secondary t-bold">Status</p>
                        </TableCell>

                        <TableCell>
                          <p className="small-dark-secondary t-bold"></p>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.prospectemployeedata.map((emp) => (
                        <TableRow key={emp.prospectemployeeid}>
                          <TableCell>
                            <p className="small-dark-secondary">{emp.fullname}</p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">{emp.emailid}</p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">
                              {emp.primarymobile ? emp.primarymobile : "-"}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">
                              {emp.inviteddate}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">{emp.status}</p>
                          </TableCell>
                          <TableCell>
                            <div>
                              {emp.requeststatusid == null && (
                                <img
                                  src={deleteIcon}
                                  className="cursour-pointer vertical-middle"
                                  onClick={() => this.onDelete(emp)}
                                ></img>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {this.state.loading && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                      Loading more employees...
                    </div>
                  )}
                  {!this.state.hasMore && this.state.prospectemployeedata.length > 0 && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                     ! You have loaded it all
                    </div>
                  )}
                  {this.state.searchTerm && this.state.prospectemployeedata.length === 0 && !this.state.loading && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                      No employees found for your search.
                    </div>
                  )}
                  {!this.state.searchTerm && this.state.prospectemployeedata.length === 0 && !this.state.loading && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                      No prospect employees to display.
                    </div>
                  )}

                </div>
              </div>
              <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="max-width-dialog-title"
              >
                <DialogTitle
                  id="max-width-dialog-title"
                  className="large-text-dark t-bold padding-bottom-0"
                >
                  Invite your team members
                </DialogTitle>
                <DialogContent>
                  <div
                    style={{
                      height: "300px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="common-menubar-header"
                      style={{ position: "unset" }}
                    >
                      <Tabs
                        value={value}
                        onChange={this.OnTabChange}
                        indicatorColor="#fff"
                        textColor="primary"
                      >
                        <Tab
                          label="Invite via email"
                          className={`tabheading invite-label ${this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                            } `}
                        />
                        <Tab
                          label="Invite via SMS"
                          className={`tabheading invite-label ${this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                            } `}
                        />
                      </Tabs>
                      <div className="tab-border"></div>
                    </div>
                    {value === 0 && (
                      <TabContainer>
                        {!this.state.invited0 ? (
                          <Grid
                            container
                            className="margin-top-16"
                            setTabValue={this.setTabValue}
                          >
                            {this.state.empdata.map((emp, index) => (
                              <Grid container>
                                <Grid
                                  item
                                  xs={12}
                                  md={3}
                                  sm={3}
                                  style={{ paddingRight: 4, paddingBottom: 8 }}
                                >
                                  <p className="input-label">
                                    Enter first name
                                    <span>*</span>
                                  </p>
                                  <TextField
                                    className="formula-input"
                                    variant="outlined"
                                    placeholder="Enter first name"
                                    onChange={(e) =>
                                      this.handleChange(
                                        "firstname",
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    value={emp.firstName}
                                    maxLength="100"
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={3}
                                  sm={3}
                                  style={{ paddingLeft: 4, paddingBottom: 8 }}
                                >
                                  <p className="input-label">Enter last name</p>
                                  <TextField
                                    className="formula-input"
                                    variant="outlined"
                                    placeholder="Enter last name"
                                    onChange={(e) =>
                                      this.handleChange(
                                        "lastname",
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    value={emp.lastName}
                                    maxLength="100"
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  sm={6}
                                  style={{ paddingLeft: 8, paddingBottom: 8 }}
                                >
                                  <p className="input-label">
                                    Enter email address
                                    <span>*</span>
                                  </p>
                                  <TextField
                                    className="formula-input"
                                    variant="outlined"
                                    type="email"
                                    placeholder="Enter email address"
                                    onBlur={(e) =>
                                      this.validateEmail(e.target.value, index)
                                    }
                                    onChange={(e) =>
                                      this.handleChange(
                                        "emailid",
                                        e.target.value,
                                        index,
                                      )
                                    }
                                    value={emp.emailId}
                                    maxLength="100"
                                  />
                                </Grid>
                              </Grid>
                            ))}
                            <Button
                              className="btn btn-primary-md-blue"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                this.setState({ invited0: false }, () =>
                                  this.addmorerows(),
                                )
                              }
                            >
                              Add more
                            </Button>
                          </Grid>
                        ) : (
                          <Grid
                            container
                            style={{
                              position: "relative",
                              top: "50%",
                              transform: "translateY(30%)",
                              textAlign: "center",
                              height: 180,
                            }}
                          >
                            <Grid item xs={12} md={12} sm={12}>
                              <div className="margin-bottom-24">
                                <img src={check}></img>
                              </div>
                              <p className="large-text-dark">
                                You have successfully invited your team members.
                              </p>
                              <div
                                style={{ textAlign: "center", marginTop: 24 }}
                              >
                                <Button
                                  className="btn btn-primary-md-blue"
                                  variant="contained"
                                  color="primary"
                                  onClick={() =>
                                    this.setState({ invited0: false })
                                  }
                                >
                                  Invite more
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      </TabContainer>
                    )}
                    {value === 1 && (
                      <TabContainer>
                        {!this.state.invited1 ? (
                          <div>
                            <Grid
                              container
                              className="margin-top-16"
                              setTabValue={this.setTabValue}
                            >
                              {this.state.empdata.map((emp, index) => (
                                <Grid container>
                                  <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    sm={3}
                                    style={{
                                      paddingRight: 4,
                                      paddingBottom: 8,
                                    }}
                                  >
                                    <p className="input-label">
                                      Enter first name
                                      <span>*</span>
                                    </p>
                                    <TextField
                                      className="formula-input"
                                      variant="outlined"
                                      placeholder="Enter first name"
                                      onChange={(e) =>
                                        this.handleChange(
                                          "firstname",
                                          e.target.value,
                                          index,
                                        )
                                      }
                                      value={emp.firstName}
                                      maxLength="100"
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    sm={3}
                                    style={{ paddingLeft: 4, paddingBottom: 8 }}
                                  >
                                    <p className="input-label">
                                      Enter last name
                                    </p>
                                    <TextField
                                      className="formula-input"
                                      variant="outlined"
                                      placeholder="Enter last name"
                                      onChange={(e) =>
                                        this.handleChange(
                                          "lastname",
                                          e.target.value,
                                          index,
                                        )
                                      }
                                      value={emp.lastName}
                                      maxLength="100"
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    sm={6}
                                    style={{ paddingLeft: 8, paddingBottom: 8 }}
                                  >
                                    <p className="input-label">
                                      Enter phone number
                                      <span>*</span>
                                    </p>
                                    <ReactPhoneInput
                                      defaultCountry={"in"}
                                      style={{ marginTop: 0 }}
                                      className="margin-top-0"
                                      onChange={(field, value) =>
                                        this.OnPhoneChange(index, field, value)
                                      }
                                      countryCodeEditable={true}
                                      value={emp.mobile}
                                      InputProps={{
                                        maxLength: 15,
                                        minLength: 5,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              ))}
                            </Grid>
                            <Button
                              className="btn btn-primary-md-blue"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                this.setState({ invited1: false }, () =>
                                  this.addmorerows(),
                                )
                              }
                            >
                              Add more
                            </Button>
                          </div>
                        ) : (
                          <Grid
                            container
                            style={{
                              position: "relative",
                              top: "50%",
                              transform: "translateY(30%)",
                              textAlign: "center",
                              height: 180,
                            }}
                          >
                            <Grid item xs={12} md={12} sm={12}>
                              <div className="margin-bottom-24">
                                <img src={check}></img>
                              </div>
                              <p className="large-text-dark">
                                You have successfully invited your team members.
                              </p>
                              <div
                                style={{ textAlign: "center", marginTop: 24 }}
                              >
                                <Button
                                  className="btn btn-primary-md-blue"
                                  variant="contained"
                                  color="primary"
                                  onClick={() =>
                                    this.setState({ invited1: false })
                                  }
                                >
                                  Invite more
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      </TabContainer>
                    )}
                  </div>
                </DialogContent>
                {this.state.value == 0 && !this.state.invited0 && (
                  <DialogActions style={{ margin: "8px 16px" }}>
                    <Button
                      onClick={this.handleClose}
                      className="btn btn-secondary-md-blue"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      color="primary"
                      onClick={this.sendDetails}
                    >
                      Invite
                    </Button>
                  </DialogActions>
                )}
                {this.state.value == 1 && !this.state.invited1 && (
                  <DialogActions style={{ margin: 16 }}>
                    <Button
                      onClick={this.handleClose}
                      className="btn btn-secondary-md-blue"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      color="primary"
                      onClick={this.sendDetails}
                    >
                      Invite
                    </Button>
                  </DialogActions>
                )}
                {this.state.value == 0 && this.state.invited0 && (
                  <DialogActions style={{ margin: 16 }}></DialogActions>
                )}
                {this.state.value == 1 && this.state.invited1 && (
                  <DialogActions style={{ margin: 16 }}></DialogActions>
                )}
              </Dialog>
            </main>
          )}
        </IntlProvider>
      </div>
    );
  }
}

InviteEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SubscriptionInfo: state.SubscriptionInfo,
  Language: state.LanguageAction.Language,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SubscriptionLogin: (data) => SubscriptionLogin(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(InviteEmployee)));